import React from "react"
import useSSR from "use-ssr"
import { BrowserRouter } from "react-router-dom"
import { Hydrate, QueryClient, QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"
import smoothscroll from "smoothscroll-polyfill"
import { UIThemeProvider } from "@capioweb/ui-components/src"
import { AppShell } from "./AppShell"
import { AppContextProvider } from "./context"
import { assetBaseUrl, printAscii } from "./utils"

import "focus-visible"

// "scroll-behaviour: smooth" polyfill for Safari - required for ScrollPanel component
smoothscroll.polyfill()

// Very important
printAscii()

const { isServer } = useSSR()
const ServerErrorPageUrl = process.env.REACT_APP_500_PAGE_ROUTE
const dehydratedState = window.__REACT_QUERY_STATE__

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			retry: false,
			onError: (error: Error) => {
				console.error(error)

				if (Number(error.message) === 500 && !isServer) {
					window.location.href = assetBaseUrl() + ServerErrorPageUrl
				}
			},
		},
	},
})

const App: React.FC = () => (
	<BrowserRouter>
		<QueryClientProvider client={queryClient}>
			<Hydrate state={dehydratedState}>
				<UIThemeProvider>
					<AppContextProvider>
						<AppShell />
					</AppContextProvider>
				</UIThemeProvider>
			</Hydrate>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	</BrowserRouter>
)

export default App
